import { fillString } from '@local_modules/generic/string-template.js'
import { hideElement, setElementHtml, showElement } from '../../../helpers/generic-js/dom.js'
import { generateRandomString } from '@local_modules/generic/text/generate-random-string/index.js'

import { checkPageRestriction } from '../../../helpers/restrictions/check-page-restriction.js'
import { applyHtmlRestrictions } from '../../../helpers/restrictions/apply-html-restrictions.js'

import htmlTemplateIndex from './index.html'
import { showTableChartsOfAccounts } from './show-table.js'
import { showMenu } from './show-menu.js'

import { loadChartOfAccountsWithStats } from '../../../helpers/app-data-loaders/load-charts-of-accounts-with-stats.js'
import { activateActions } from './activate-actions.js'

/**
 *
 * @returns
 */
export async function showPageChartOfAccountsPG (params) {
  console.log('showPageChartOfAccountsPG')

  const { containerElementId, browserAppUser, browserAppAccount } = params

  if (!checkPageRestriction({ browserAppUser, browserAppAccount, allowPublic: true })) return

  // Prepare the html
  let htmlIndex = htmlTemplateIndex
  htmlIndex = applyHtmlRestrictions(htmlIndex, { browserAppAccount, browserAppUser })
  const elementId = 'i' + generateRandomString()
  htmlIndex = fillString(htmlIndex, { elementId })

  // Inject in the page
  setElementHtml(containerElementId, htmlIndex)

  document.title = ['Chart of Accounts:', browserAppAccount.data.appAccount.name].join(' ')

  // Set full height
  document.getElementById(containerElementId)?.classList.add('position-absolute')
  document.getElementById(containerElementId)?.classList.add('top-to-bottom')

  showElement('loadingFeedback')

  const chartOfAccountResponse = await loadChartOfAccountsWithStats(browserAppAccount.data.appAccount.id)

  showMenu()

  const gridApi = showTableChartsOfAccounts(chartOfAccountResponse)

  hideElement('loadingFeedback')

  activateActions(gridApi)
}
